import type { Login } from "~/models/generated/Login";

/**
 * Require a logged in member to view the page(s) using this middleware.
 * If not logged in, the user will be redirected to the login page.
 */

export default defineNuxtRouteMiddleware( async ( to ) => {
  const store = useAuthStore();

  // Check if the 'auth' cookie exists and the user is logged in
  if ( !store.isLoggedIn ) {
    const resource = useContentDeliveryResource();
    const login = await resource.getByTypeSingle<Login>( "login" );

    if ( login.error.value ) {
      throw createError( {
        message: "Cannot get login page",
        fatal: true,
        cause: login.error.value,
      } );
    }

    // User is not authenticated, redirect to login page
    const redirectUrl = encodeURIComponent( to.fullPath );
    return navigateTo( `${login.data.value.route.path}?redirectUrl=${redirectUrl}` );
  }
} );
